import UpdateFilterUrl from "./updatefilterurl.js";
import FilterValues from "./filtervalues.js";
import SelectedFilters from "./selectedfilters.js";
import { prodListValues } from './shared.js';

const quantityText = document.getElementById('txtProductQuantity');
const submit = document.getElementById('submitProductQuantity');
const mobileFilterDropDown = document.getElementById('filterDropDown');

class ProductQuantityFilter {
    /**
     * Initializes the product quantity filter by setting up event listeners for the submit button and the quantity text input.
     * @return {void}
     */
    events() {
        if (submit && quantityText) {
            submit.addEventListener('click', (e) => {
                e.preventDefault();
                let productQuantity = quantityText.value;

                if (productQuantity.length === 0) {
                    this.clear();
                    UpdateFilterUrl.update(FilterValues, prodListValues, false);
                } else {
                    this.add(true);
                    UpdateFilterUrl.update(FilterValues, prodListValues, false);
                }

                if (mobileFilterDropDown.classList.contains('active')) {
                    mobileFilterDropDown.click();
                }
            });

            quantityText.addEventListener('keydown', (e) => {
                if (e.key === 'Enter') {
                    e.preventDefault();
                    submit.click();
                }
            });
        }
    };

    /**
     * Adds a product quantity filter.
     * @param {boolean} logFilter Whether to log the filter addition.
     * @return {void}
     */
    add(logFilter) {
        let filterName = document.getElementById('ProductQuantityFilterTitle').value.replace('##productquantity##', quantityText.value);

        SelectedFilters.removeFromSelectedFilter(quantityText);
        FilterValues.addProductQuantityFilter(quantityText.id, quantityText.value, logFilter);
        quantityText.value = '';
        SelectedFilters.addToSelectedFilter(quantityText, filterName);
    };

    /**
     * Updates the product quantity filter with a new term.
     * @param {string} term The new product quantity term.
     * @return {void}
     */
    update(term) {
        quantityText.value = term;
        this.add(true);
    };

    /**
     * Clears the product quantity filter.
     * @return {void}
     */
    clear() {
        quantityText.value = '';
        FilterValues.removeProductQuantityFilter();
        SelectedFilters.removeFromSelectedFilter(quantityText);
    };
}

export default new ProductQuantityFilter();